module.exports = __webpack_public_path__ + "img/OS-logo-original.3a3d2b32.png";